import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { SortDirection } from 'src/@smartmanufacturing/common/enum';
import { Group, GroupDetail } from 'src/app/user-management/group-setup/models/group';
import { DataMapper } from 'src/app/user-management/shared/models/data-mapper';

import { BaseApi } from 'src/backend/api/base-api';

@Injectable({
    providedIn: 'root'
})
export class GroupService {

    constructor(private http: HttpClient, private baseApi: BaseApi) { }

    getAllGroups(data: any): Observable<DataMapper<Group>> {
        let params = '';
        if (data?.pageIndex) {
            params += 'offset=' + data?.pageIndex.toString();
        }
        if (data?.pageSize) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'limit=' + data?.pageSize.toString();
        }
        if (data?.grpStatus) {
            if (params.length > 0) {
                params += '&';
            }
            params += `status=` + data?.grpStatus;
        }
        if (data?.sortDirection !== SortDirection.None) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortDirection=' + data?.sortDirection;
        }
        if (data?.sortField) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortField=' + data?.sortField;
        }
        if (data?.searchValue) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'phrase=' + data?.searchValue;
        }
        return this.http.get<DataMapper<Group>>(this.baseApi.encodeURL(Constants.API_GETALL_GROUPS + '?' + params));
    }
    createGroup(data: any): Observable<any> {
        return this.http.post<any>(this.baseApi.encodeURL(Constants.API_GROUP_CREATE), data);
    }
    editGroup(data: any): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_GROUP_EDIT), data);
    }

    getGroupById(grpId: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_GROUP_BY_ID + '/' + grpId));
    }

    activateGroup(id: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_GROUP_ACTIVATE + '/' + id));
    }
    deactivateGroup(id: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_GROUP_DEACTIVATE + '/' + id));
    }

    getGroupDetail(code: string): Observable<GroupDetail> {
        return this.http.get<GroupDetail>(this.baseApi.encodeURL(Constants.API_GROUP_DETAILS + '/' + code));
    }

}
